/* eslint-disable react-hooks/exhaustive-deps */ import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
/**
 * Attaches a resize watcher on the section. When size updates, relevant section information is updated.
 *
 * @param {Object} props - The properties for the Section component.
 * @param {ReactNode} props.children - The child components to be rendered within the section.
 * @param {string} props.id - The unique identifier for the section.
 * @param {string} [props.id] - An optional search identifier for the section.
 * @returns {JSX.Element} A JSX element representing the Section component.
 */ export default function Section({ id, children, sectionIndex = 0, onUpdate = ()=>{} }) {
    const divRef = useRef(null);
    const [height, setHeight] = useState(0); // cache height on resize
    const handleHeightUpdate = (heightVal)=>{
        heightVal = heightVal ? heightVal : height;
        setHeight(heightVal);
        onUpdate(sectionIndex, heightVal);
    };
    useEffect(()=>{
        handleHeightUpdate();
        const resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries){
                if (entry.target === divRef.current) {
                    const newHeight = entry.contentRect.height;
                    handleHeightUpdate(newHeight);
                }
            }
        });
        if (divRef.current) {
            resizeObserver.observe(divRef.current);
        }
        return ()=>{
            if (divRef.current) {
                resizeObserver.unobserve(divRef.current);
            }
            resizeObserver.disconnect();
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        ref: divRef,
        id: id || sectionIndex,
        children: children
    });
}
